var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLesTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 28,
    viewBox: "0 0 114 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5394 0.5L12.1572 0.677673L9.27231 4.09873L8.94998 4.48096L9.33222 4.80329L4.20718 10.8809L3.82494 10.5586L3.50261 10.9408L0.617763 14.3619L0.635133 15.0261L3.51998 18.105L3.86185 18.4699L4.22671 18.128L9.31268 23.5562L8.94781 23.8981L9.28968 24.2629L12.1745 27.3419L12.5394 27.5H34.6H35.1V27H78.2212V27.5H78.7212H100.782L101.137 27.3521L104.191 24.2732L104.543 23.9182L104.189 23.5661L109.593 18.1181L109.948 18.4703L110.3 18.1153L113.355 15.0364L113.373 14.3512L110.318 10.9301L109.985 10.5572L109.612 10.8902L104.169 4.79402L104.542 4.46101L104.209 4.08804L101.155 0.66699L100.782 0.5H78.7212H78.2212V1H35.1V0.5H34.6H12.5394Z",
    fill: "#E9F7FA",
    stroke: "#00739F",
    strokeMiterlimit: 4.80973,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeDasharray: "76 76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesTop);
export default __webpack_public_path__ + "static/media/les-top.c78735e9c97ef909b8183a51e1802d3f.svg";
export { ForwardRef as ReactComponent };